"use client";

import Link from "next/link";
import toast from "react-hot-toast";
import axios from "@/services/axios";
import { useState } from "react";
import { useAuth } from "@/hooks/useAuth";

import Tabs from "../appcomponents/Tabs";
import PaymentModal from "../PaymentModal";
import Layout from "../appcomponents/Layout";
import PricingCard from "../appcomponents/PricingCard";
import CenikMemorialSection from "./CenikMemorialSection";
import CenikAdvertisingSection from "./CenikAdvertisingSection";
import WhatIsIncludedPopupAdvertisers from "../appcomponents/WhatIsIncludedPopupAdvertisers";
import Breadcrumbs from "../appcomponents/Breadcrumbs";
import Image from "next/image";

const SubscriptionMobile = () => {
  const { user, isAuthenticated, isRole } = useAuth();

  const tabs = [
    { id: "spominske", label: "Spominske" },
    { id: "oglasevalci", label: "Oglaševanje" },
    // { id: "pogrebna-podjetja", label: "Pogrebna podjetja" },
  ];
  const formtabsoglasevalci = [
    { id: "mesecno", label: "MESEČNO" },
    { id: "letno", label: "LETNO*" },
  ];

  const [active, setActive] = useState("spominske");
  const [activeFormTabOglasevalci, setActiveFormTabOglasevalci] =
    useState("mesecno");
  const [paymentModal, setPaymentModal] = useState({
    isOpen: false,
    packageType: null,
    customCode: null,
  });
  const [isWhatIsIncludedAdvertisersOpen, setIsWhatIsIncludedAdvertisersOpen] =
    useState(false);

  const handlePayment = (packageType, customCode = null) => {
    setPaymentModal({
      isOpen: true,
      packageType,
      customCode,
    });
  };

  const handleCustomCodeSubmit = (code, type) => {
    // Map the code to the appropriate package type
    const codeToPackageMap = {
      "CUSTOM-001": "custom_one",
      "CUSTOM-002": "custom_two",
    };

    const packageType = codeToPackageMap[code];
    if (!packageType) {
      toast.error(
        "Neveljavna koda. Prosimo preverite kodo in poskusite znova.",
      );
      return;
    }

    handlePayment(packageType, code);
  };

  const handleManagePayments = async () => {
    if (!user) {
      toast.error("Potrebna je prijava");
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.NEXT_PUBLIC_API_URL}/payment/portal`,
        {
          headers: { "access-token": localStorage.getItem("access-token") },
        },
      );

      if (response.data.success) {
        window.open(response.data.data.portalUrl, "_blank");
      }
    } catch (error) {
      if (error.response?.status === 404) {
        toast.error("Ni najdenih plačil za upravljanje");
      } else {
        toast.error(
          error.response?.data?.message || "Napaka pri dostopu do portala",
        );
      }
    }
  };

  const FormTabsContentOglasevalci = () => {
    switch (activeFormTabOglasevalci) {
      case "mesecno":
        return (
          <div className="flex flex-col gap-4">
            <PricingCard
              label="MESEČNO"
              title="Manjša mesta"
              price="10 €"
              onPayment={() => handlePayment("advertiser_monthly_small_city")}
              paymentEnabled={false}
            />
            <PricingCard
              label="MESEČNO"
              price="20 €"
              title="Večja mesta"
              number={1}
              onPayment={() => handlePayment("advertiser_monthly_large_city")}
              paymentEnabled={false}
            />
            <PricingCard
              label="MESEČNO"
              price="30 €"
              title="Ljubljana"
              onPayment={() => handlePayment("advertiser_monthly_capital_city")}
              paymentEnabled={false}
            />
            <PricingCard
              label="MESEČNO"
              title="Regijsko"
              number={2}
              clickable={false}
            />
            {/* <CustomPackageCard 
              type="advertiser"
              onCodeSubmit={(code) => handleCustomCodeSubmit(code, 'advertiser')}
            /> */}
          </div>
        );
      case "letno":
        return (
          <div className="flex flex-col gap-4">
            <PricingCard
              label="LETNO"
              title="Manjša mesta"
              price="100 €"
              onPayment={() => handlePayment("advertiser_yearly_small_city")}
              paymentEnabled={false}
            />
            <PricingCard
              label="LETNO"
              price="200 €"
              title="Večja mesta"
              number={1}
              onPayment={() => handlePayment("advertiser_yearly_large_city")}
              paymentEnabled={false}
            />
            <PricingCard
              label="LETNO"
              price="300 €"
              title="Ljubljana"
              onPayment={() => handlePayment("advertiser_yearly_capital_city")}
              paymentEnabled={false}
            />
            <PricingCard
              label="LETNO"
              title="Regijsko"
              number={2}
              clickable={false}
            />
            {/* <CustomPackageCard 
              type="advertiser"
              onCodeSubmit={(code) => handleCustomCodeSubmit(code, 'advertiser')}
            /> */}
          </div>
        );
      default:
        return null;
    }
  };

  // Called (not rendered as <TabContent />): a component defined inside this one would be a new type on
  // every render and remount everything below it, closing any open order popup.
  const TabContent = () => {
    switch (active) {
      case "spominske":
        return <CenikMemorialSection />;

      case "oglasevalci":
        return <CenikAdvertisingSection onShowIncluded={() => setIsWhatIsIncludedAdvertisersOpen(true)} />;

      case "pogrebna-podjetja":
        return (
          <div className="p-4 mb-[40px] mobile:max-w-[500px] max-w-[766px] w-full mx-auto mobile:mx-auto flex flex-col mobile:items-center tablet:items-center mobile:justify-center space-y-4">
            <div className=" w-full flex flex-col gap-4">
              <div className="w-full flex items-center gap-4">
                <div className="mobile:text-[24px] text-[32px] text-[#000000]">
                  Pogrebna podjetja
                </div>
              </div>
              <div className="text-[#414141] flex gap-1 w-full mobile:text-[14px] text-[16px]">
                <p className="text-[14px]"></p>{" "}
                <p className="mt-1">
                  Vse je brezplačno. Registrirajte se in vse potrebne
                  informacije vas čakajo v vašem uporabniškem računu.
                </p>
              </div>
              <p className="text-[16px] text-[#0A85C2] leading-[24px] underline underlin-offset-2 mt-7">
                Kontaktirajte nas
              </p>
              {/* <div
                className="w-full flex justify-end mt-[60px] desktop:w-[744px]"
                style={{ marginTop: "60px" }}
              >
                <Link href={"/kontakt"}>
                  <Image
                    src={"/Kontaktirajte_nas_btn.png"}
                    alt="Kontaktirajte nas"
                    width={250}
                    height={60}
                  />
                </Link> */}
              {/* <div
                  className="flex w-[250px] h-[60px] rounded-full bg-transparent"
                  style={{
                    boxShadow: "5px 5px 10px 0px #A6ABBD",
                    border: "0.5px solid #6D778E66",
                  }}
                >
                  <Link
                    href={"/kontakt"}
                    className={`w-[250px] h-[60px] shrink-0 rounded-full text-[#3C3E41] justify-center items-center self-center shadow-custom-light-dark flex font-semibold text-[20px]`}
                    style={{
                      background:
                        "background: linear-gradient(0deg, rgba(231, 235, 240, 0.3), rgba(231, 235, 240, 0.3)), linear-gradient(180deg, rgba(0, 0, 0, 0) 60.83%, rgba(24, 96, 163, 0.1) 100%)",
                      boxShadow: "inset -5px -5px 10px 0px #A6ABBD",
                    }}
                  >
                    Kontaktirajte nas
                  </Link>
                </div> */}
              {/* </div> */}
            </div>
          </div>
        );

      default:
        return null;
    }
  };
  const activeTab = tabs.find((tab) => tab.id === active);
  const breadcrumbItems = [{ label: "Domov", href: "/" }, { label: "Cenik" }];
  if (activeTab) {
    breadcrumbItems.push({ label: activeTab.label });
  }

  return (
    <>
      <Layout from={"23"} forFooter={"cenikpage"}>
        <div
          className={`cenik-page-wrapper w-full bg-[#ECF0F3] flex flex-col items-center mobile:py-3 py-8 ${
            (
              (active === "oglasevalci" && isWhatIsIncludedAdvertisersOpen)
            ) ?
              "mb-[-2rem]"
            : "lg:px-8"
          }`}
        >
          <div className="w-full desktop:w-[1200px] mx-auto">
            <div className="-mt-[20px]">
              <Breadcrumbs items={breadcrumbItems} />
            </div>
            {/* Manage Payments Button for logged in users */}
            {/* Temporarily removed for this week */}
            {/* {user && (active === "spominske" || active === "cvetlicarne") && (
              <div className="flex justify-center mb-6">
                <Button
                  variant="bordered"
                  onClick={handleManagePayments}
                  className="bg-slate-50 rounded-xl right-0 text-slate-600"
                >
                  Upravljaj plačila
                </Button>
              </div>
            )} */}

            <Tabs
              light
              tabs={tabs}
              tabContent={
                (
                  (active === "oglasevalci" && isWhatIsIncludedAdvertisersOpen)
                ) ?
                  null
                : TabContent()
              }
              active={active}
              setActive={setActive}
            />

            {/* Payment Modal */}
            <PaymentModal
              isOpen={paymentModal.isOpen}
              onClose={() =>
                setPaymentModal({
                  isOpen: false,
                  packageType: null,
                  customCode: null,
                })
              }
              packageType={paymentModal.packageType}
              customCode={paymentModal.customCode}
              onPaymentCreated={(data) => {
                setPaymentModal({
                  isOpen: false,
                  packageType: null,
                  customCode: null,
                });
                toast.success("Preusmerjamo na plačilo...");
              }}
            />
          </div>

          {active === "oglasevalci" && isWhatIsIncludedAdvertisersOpen && (
            <WhatIsIncludedPopupAdvertisers
              onClose={() => setIsWhatIsIncludedAdvertisersOpen(false)}
            />
          )}
        </div>
      </Layout>
    </>
  );
};

export default SubscriptionMobile;
